var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bread"},[_c('el-breadcrumb',{staticClass:"el-bread",attrs:{"separator":"/"}},_vm._l((_vm.$route.matched),function(ref,index){
var title = ref.meta.title;
return _c('el-breadcrumb-item',{key:index},[_c('span',{class:_vm.addAnimationClass(index)},[_vm._v(_vm._s(_vm.$t(title)))])])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }